import TabsBalance from './Tabs';

export default TabsBalance;
